import { render, staticRenderFns } from "./AnnouncementView.vue?vue&type=template&id=bf66df0a"
import script from "./AnnouncementView.vue?vue&type=script&lang=js"
export * from "./AnnouncementView.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports